import React from 'react';
interface ChatBadgeProps {
  color: string;
}
const ChatBadge = ({color}: ChatBadgeProps) => {
  return (
    <div
      className={`absolute flex w-[10px] h-[10px] top-[14.91%] right-[4%] rounded-full ${color} `}
    />
  );
};

export default ChatBadge;
